import { Navigate } from 'react-router-dom';
import { useAuth } from './use-auth';
import { useConfig } from '../bootstrap/ConfigProvider';
import AccessDenied from './AccessDenied';

// show only for authenticated users
export function RequireAuth({ roles = [], children }) {
    const { isAuthenticated, user } = useAuth();
    const { requiresSingleTenantSignUp } = useConfig();

    if (!isAuthenticated) {
        const pathname = requiresSingleTenantSignUp ? '/CreateNewAccount' : '/login';

        return <Navigate to={pathname} replace />;
    }

    const isAuthorizedRole = !roles.length || roles.includes(user.roleName);

    if (!isAuthorizedRole) {
        return <AccessDenied />;
    }

    return children;
}

// show only if there is no authenticated user
export function RequireNoAuth({ children }) {
    const { isAuthenticated } = useAuth();

    return isAuthenticated ? <Navigate to='/' replace /> : children;
}
